<template>
  <div class="demand-list" :class="{ 'locale-zh-CN': isZhLocale }">
    <div 
      v-for="(item, index) in items" 
      :key="item.id || index"
      class="demand-item"
      @click="handleItemClick(item)"
    >
      <div class="item-header">
        <span class="item-tag"></span>
      </div>
      <h4 class="item-title">{{ item.title }}</h4>
      <div class="item-meta">
        <span class="meta-label">{{ item.cooperationType || cooperationType }}</span>
        <span class="separator">|</span>
        <span class="meta-price">{{ feeLabel }}<span class="highlight">{{ item.price }}</span></span>
      </div>
      <div class="item-info">
        <div class="info-row">
          <span>{{ organizationLabel }}{{ item.organization }}</span>
        </div>
        <div class="info-row">
          <span>{{ locationLabel }}{{ item.location }}</span>
        </div>
        <div class="info-row">
          <span>{{ deadlineLabel }}{{ item.deadline }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getText } from '@/utils/i18nText'

export default {
  name: 'DemandList',
  props: {
    // 需求列表数据
    items: {
      type: Array,
      default: () => []
    },
    // 合作方式
    cooperationType: {
      type: String,
      default: () => getText('demandList.cooperationType', '合作开发')
    },
    // 费用标签
    feeLabel: {
      type: String,
      default: () => getText('demandList.feeLabel', '费用：')
    },
    // 所属单位标签
    organizationLabel: {
      type: String,
      default: () => getText('demandList.organizationLabel', '所属单位：')
    },
    // 所在地标签
    locationLabel: {
      type: String,
      default: () => getText('demandList.locationLabel', '所在地：')
    },
    // 截止时间标签
    deadlineLabel: {
      type: String,
      default: () => getText('demandList.deadlineLabel', '截止时间：')
    }
  },
  methods: {
    handleItemClick(item) {
      this.$emit('item-click', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.demand-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  
  .demand-item {
    background: #FFFFFF;
    border-radius: 4px;
    padding: 0;
    position: relative;
    overflow: visible;
    border: 1px solid rgba(160, 144, 60, 0.2);
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    height: 100%;
    
    // 右下角装饰图片
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 170px;
      height: 168px;
      background-image: url('~@/assets/img/gongxuzhongxin/xuqiudating-item-bg-right-ico.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: right center;
      opacity: 0.15;
      transition: opacity 0.3s;
      pointer-events: none;
      z-index: 1;
    }
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-3px);
      border-color: rgba(160, 144, 60, 0.4);
      
      &::after {
        opacity: 0.3;
      }
    }
    
    .item-header {
      margin-bottom: 0;
      position: relative;
      z-index: 2;
      
      .item-tag {
        position: absolute;
        top: 0;
        left: 0;
        margin-left: 31px;
        min-width: 18px;
        height: 11px;
        background: #8C7B21;
        color: #FFFFFF;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        border-radius: 0 0 4px 0;
        z-index: 2;
      }
    }
    
    .item-title {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      margin-top: 20px;
      margin-left: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      position: relative;
      z-index: 2;
    }
    
    .item-meta {
      margin-left: 30px;
      display: flex;
      margin-top: 8px;
      align-items: center;
      gap: 6px;
      margin-bottom: 10px;
      font-family: Source Han Sans CN;
      font-size: 12px;
      position: relative;
      z-index: 2;
      
      .meta-label {
        color: #887825;
      }
      
      .separator {
        color: #DDDDDD;
      }
      
      .meta-price {
        color: #666666;
        
        .highlight {
          color: #FF0000;
          font-weight: 500;
          margin-left: 2px;
        }
      }
    }
    
    .item-info {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #777777;
      padding: 10px 30px 12px 30px;
      margin-top: auto;
      position: relative;
      background-image: url('~@/assets/img/gongxuzhongxin/xuqiudating-item-bg-bottom.png');
      background-repeat: no-repeat;
      background-position: bottom center;
      background-size: 100% auto;
      z-index: 2;
      
      .info-row {
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
